// Keep the section, while leaving record IDs and account-specific filters behind.
export const accountSwitchPath = (route, router, accountId) => {
  const base = `/app/accounts/${encodeURIComponent(accountId)}`;
  const fallback = `${base}/dashboard`;
  const accountPrefix = /^\/app\/accounts\/[^/]+/;
  if (!accountPrefix.test(route.path || '')) return fallback;

  const extraParams = Object.entries(route.params || {}).filter(
    ([key, value]) => key !== 'accountId' && value !== '' && value != null
  );
  if (!extraParams.length) return route.path.replace(accountPrefix, base);

  const pattern = route.matched?.at(-1)?.path || '';
  const segments = pattern.split('/');
  const recordIndex = segments.findIndex(
    part => part.startsWith(':') && part !== ':accountId'
  );
  let candidate = segments
    .slice(0, recordIndex < 0 ? 0 : recordIndex)
    .join('/')
    .replace('/:accountId', `/${encodeURIComponent(accountId)}`);

  while (candidate.startsWith(`${base}/`)) {
    const resolved = router.resolve(candidate);
    const params = Object.keys(resolved.params || {});
    if (resolved.matched.length && params.every(key => key === 'accountId')) {
      return candidate;
    }
    candidate = candidate.slice(0, candidate.lastIndexOf('/'));
  }

  if (
    'conversation_id' in (route.params || {}) ||
    /^\/(inbox|label|team|custom_view|conversation-filters)\//.test(
      route.path.replace(accountPrefix, '')
    )
  ) {
    return `${base}/atendimentos`;
  }
  return fallback;
};
